<template>
  <div class="cl">
    <div class="cl__inner">
      <header class="cl__head">
        <svg class="cl__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 436.722 196.02" role="img" aria-label="Inqi">
          <g transform="translate(-181.639 -301.99)" fill="#b51a3e">
            <path d="M200.442,323.826a18.578,18.578,0,1,1,18.579,18.58,18.578,18.578,0,0,1-18.579-18.58"/>
            <path d="M242.222,363.76c-.627-4.154-3.625-14.423-17.971-14.423h-1.5c-2.2.039-4.938.278-5,.284l-30.847,2.936a4.942,4.942,0,0,0-1.969.822c-.08.065-.133.139-.207.207a4.5,4.5,0,0,0-1.3,2.031,9.119,9.119,0,0,0-.417,1.358c0,.017-.012.023-.012.044,0,.006,0,.006,0,.015s-.017.088-.017.088l-1.34,16.475-.009.568a3.312,3.312,0,0,0,.991,2.365,3.357,3.357,0,0,0,2.365,1.017l17.731-1.836a4.185,4.185,0,0,1,4.586,3.743l6.091,61c.751,4.6,4.21,14.987,20.283,15.162,14.023.153,16.365-8.152,16.427-13.5Z"/>
            <path d="M336.106,377.23q-4.62-3.738-12.321-3.74a33.57,33.57,0,0,0-9.679,1.32,44.848,44.848,0,0,0-8.14,3.3v77.88a43.541,43.541,0,0,1-6.16,1.21,64.762,64.762,0,0,1-8.8.55q-9.9,0-14.3-3.19t-4.4-12.431V374.15a16,16,0,0,1,2.42-9.24,26.743,26.743,0,0,1,6.82-6.6q7.038-5.058,18.15-8.14a91.712,91.712,0,0,1,24.531-3.08q23.976,0,37.068,10.56t13.092,30.14v68.2a53.11,53.11,0,0,1-6.381,1.21,64.767,64.767,0,0,1-8.8.55q-9.9,0-14.189-3.19t-4.289-12.431v-53.46Q340.727,380.972,336.106,377.23Z"/>
            <path d="M501.545,496.03a52.347,52.347,0,0,1-6.271,1.32,54.315,54.315,0,0,1-8.689.66q-9.9,0-14.3-3.3t-4.4-12.54V456.43a55.533,55.533,0,0,1-8.691,2.2,59.83,59.83,0,0,1-10.449.88,64.675,64.675,0,0,1-21.78-3.519,45.966,45.966,0,0,1-28.49-27.941,67.575,67.575,0,0,1-4.069-24.42q0-14.074,4.289-24.639a47.186,47.186,0,0,1,12.1-17.6,52.163,52.163,0,0,1,18.7-10.67,76.575,76.575,0,0,1,24.309-3.63,82.2,82.2,0,0,1,22.55,2.97q10.447,2.97,16.17,6.71a21.929,21.929,0,0,1,6.71,6.49,17.154,17.154,0,0,1,2.311,9.35Zm-47.96-63.14a28.056,28.056,0,0,0,14.519-3.74V376.79a39.927,39.927,0,0,0-5.719-2.2,26.561,26.561,0,0,0-7.92-1.1q-11.88,0-18.92,7.37t-7.04,22.769q0,15.182,6.6,22.221T453.585,432.89Z"/>
            <path d="M525.744,320.03a17.57,17.57,0,0,1,5.17-12.76q5.166-5.28,13.529-5.28t13.53,5.28a17.582,17.582,0,0,1,5.17,12.76,17.841,17.841,0,0,1-5.17,12.98q-5.171,5.28-13.53,5.28t-13.529-5.28A17.829,17.829,0,0,1,525.744,320.03Zm35.42,135.96A43.571,43.571,0,0,1,555,457.2a64.774,64.774,0,0,1-8.8.55q-9.9,0-14.191-3.19t-4.29-12.431V351.71a52.8,52.8,0,0,1,6.161-1.32,53.732,53.732,0,0,1,8.8-.66q9.9,0,14.191,3.3t4.29,12.54Z"/>
            <path d="M579.2,439.93a20.23,20.23,0,0,1,5.17-14.08q5.166-5.718,14.41-5.721,9.018,0,14.3,5.721a21.412,21.412,0,0,1,0,28.159q-5.28,5.719-14.3,5.721-9.24,0-14.41-5.721A20.214,20.214,0,0,1,579.2,439.93Z"/>
          </g>
        </svg>
        <h1 class="cl__title">Novedades de Inqi</h1>
        <p class="cl__lead">Lo nuevo en el panel web y la app, versión por versión.</p>
      </header>

      <ol class="cl__timeline">
        <li
          v-for="(release, i) in changelog"
          :key="release.date + '-' + i"
          class="cl__release"
        >
          <span class="cl__node" :class="{ 'cl__node--latest': i === 0 }"></span>

          <div class="cl__meta">
            <time class="cl__date">{{ formatDate(release.date) }}</time>
            <span class="cl__versions">
              <span v-if="release.versions.web" class="cl__ver cl__ver--web">
                Web {{ shortVersion(release.versions.web) }}
              </span>
              <span v-if="release.versions.app" class="cl__ver cl__ver--app">
                App {{ shortVersion(release.versions.app) }}
              </span>
            </span>
          </div>

          <h2 class="cl__name">{{ release.title }}</h2>
          <p v-if="release.summary" class="cl__summary">{{ release.summary }}</p>

          <div
            v-for="(section, j) in release.sections"
            :key="j"
            class="cl__section"
          >
            <span class="cl__surface">{{ surfaceLabel(section.surface) }}</span>
            <ul class="cl__items">
              <li
                v-for="(item, k) in section.items"
                :key="k"
                class="cl__item"
              >
                <span class="cl__tag" :class="'cl__tag--' + item.tag">{{ tagLabel(item.tag) }}</span>
                <span class="cl__text">{{ item.text }}</span>
              </li>
            </ul>
          </div>
        </li>
      </ol>

      <footer class="cl__foot">
        <p>Inqi — Gestión de alquileres · <a href="mailto:hola@inqiapp.com">hola@inqiapp.com</a></p>
      </footer>
    </div>
  </div>
</template>

<script>
import { changelog } from '@/content/changelog-public'

const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
const TAG_LABELS = {
  nuevo: 'Nuevo',
  mejora: 'Mejora',
  fix: 'Corregido',
  eliminado: 'Eliminado',
  seguridad: 'Seguridad',
  admin: 'Admin'
}

export default {
  name: 'ChangelogPage',
  data () {
    return { changelog }
  },
  methods: {
    // 1.4.0 → "1.4" ; 0.2.1 → "0.2.1" (muestra patch solo si > 0)
    shortVersion (version) {
      const [major, minor, patch] = version.split('.')
      return Number(patch) > 0 ? `${major}.${minor}.${patch}` : `${major}.${minor}`
    },
    surfaceLabel (surface) {
      return surface === 'app' ? 'App' : 'Panel web'
    },
    tagLabel (tag) {
      return TAG_LABELS[tag] || tag
    },
    formatDate (dateStr) {
      const [year, month, day] = dateStr.split('-')
      return `${parseInt(day, 10)} ${MONTHS[parseInt(month, 10) - 1]} ${year}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/base/config";

.cl {
  min-height: 100vh;
  background: #ffffff;
  color: $black;
  font-family: $font-base;
  -webkit-font-smoothing: antialiased;
}

.cl__inner {
  max-width: 760px;
  margin: 0 auto;
  padding: $space-48 $space-24 $space-96;
}

/* ── Header ── */
.cl__head {
  margin-bottom: $space-48;
}

.cl__logo {
  height: 28px;
  width: auto;
  display: block;
  margin-bottom: $space-24;
}

.cl__title {
  font-family: $font-display;
  font-size: $h01;
  font-weight: $bold;
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin: 0 0 $space-8;
}

.cl__lead {
  font-size: $main;
  color: $darker-grey;
  margin: 0;
}

/* ── Timeline ── */
.cl__timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cl__release {
  position: relative;
  padding: 0 0 $space-48 $space-32;
  border-left: 2px solid $lighter-grey;

  &:last-child {
    border-left-color: transparent;
    padding-bottom: 0;
  }
}

.cl__node {
  position: absolute;
  left: -7px;
  top: 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: $secondary-color;
  box-shadow: 0 0 0 4px #ffffff;

  &--latest {
    box-shadow: 0 0 0 4px #ffffff, 0 0 0 7px rgba($secondary-color, 0.18);
  }
}

/* ── Meta: date + version badges ── */
.cl__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: $space-8 $space-12;
  margin-bottom: $space-8;
}

.cl__date {
  font-size: $small;
  font-weight: $medium;
  color: $dark-grey;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.cl__versions {
  display: inline-flex;
  gap: $space-8;
}

.cl__ver {
  font-size: $tiny;
  font-weight: $semiBold;
  padding: 2px $space-8;
  border-radius: $border-radius-pill;
  white-space: nowrap;

  &--web {
    color: $secondary-color;
    background: rgba($secondary-color, 0.10);
  }

  &--app {
    color: $black;
    background: rgba($black, 0.07);
  }
}

/* ── Title + summary ── */
.cl__name {
  font-family: $font-sub;
  font-size: $h04;
  font-weight: $semiBold;
  letter-spacing: $letter-spacing;
  line-height: 1.25;
  margin: 0 0 $space-4;
}

.cl__summary {
  font-size: $main;
  color: $darker-grey;
  line-height: 1.5;
  margin: 0 0 $space-16;
}

/* ── Sections ── */
.cl__section {
  margin-top: $space-16;
}

.cl__surface {
  display: inline-block;
  font-size: $tiny;
  font-weight: $semiBold;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: $dark-grey;
  margin-bottom: $space-8;
}

.cl__items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cl__item {
  display: flex;
  align-items: flex-start;
  gap: $space-12;
  padding: $space-4 0;
  font-size: $main;
  line-height: 1.45;
}

.cl__text {
  color: $black;
}

/* ── Tag pills ── */
.cl__tag {
  flex: none;
  margin-top: 2px;
  min-width: 70px;
  text-align: center;
  font-size: 0.6875rem;
  font-weight: $semiBold;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 3px $space-8;
  border-radius: 5px;

  &--nuevo { color: #1e7d4e; background: #e8f7ef; }
  &--mejora { color: #1d4ed8; background: #eaf0fe; }
  &--fix { color: #9a6206; background: #fcf1df; }
  &--eliminado { color: #c42420; background: #ffeceb; }
  &--seguridad { color: #3a4452; background: #eef0f3; }
  &--admin { color: $secondary-color; background: rgba($secondary-color, 0.10); }
}

/* ── Footer ── */
.cl__foot {
  margin-top: $space-48;
  padding-top: $space-24;
  border-top: 1px solid $color-borders;
  font-size: $small;
  color: $grey;

  p { margin: 0; }

  a {
    color: $dark-grey;
    text-decoration: none;

    &:hover { color: $secondary-color; }
  }
}

@media (max-width: 560px) {
  .cl__inner { padding: $space-32 $space-16 $space-62; }
  .cl__title { font-size: $h02; }
  .cl__release { padding-left: $space-24; }
  .cl__tag { min-width: 62px; }
}
</style>
